import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-12 px-6 bg-blush-light relative" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-127">
          <h2 className="text-4xl md:text-5xl font-playfair text-burgundy-deep mb-6" data-id="element-128">
            Anestesia Sensorial
          </h2>
          <div className="w-16 h-[1px] bg-gold mx-auto" data-id="element-129" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12" data-id="element-130">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="md:col-span-1 hidden md:flex justify-center" data-id="element-131">
            <div className="w-[1px] h-full bg-gradient-to-b from-gold/0 via-gold to-gold/0" data-id="element-132" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="md:col-span-11 space-y-8 text-lg text-charcoal/80 leading-relaxed" data-id="element-133">
            <p className="text-center" data-id="element-134">
              Llegas al final del día tan saturada de decisiones, ruidos y
              demandas que, cuando finalmente tienes un momento para la
              intimidad, tu cuerpo se siente como una armadura.
            </p>
            <p className="text-center" data-id="element-135">
              El contacto físico se siente como "una demanda más". El deseo no
              aparece porque tu cerebro está demasiado ocupado escaneando
              amenazas (emails, facturas, platos sucios) como para permitirse el
              lujo de sentir.
            </p>
            <p className="text-center font-medium text-burgundy-deep" data-id="element-136">
              Estás operando en piloto automático, funcional para el mundo pero
              invisible para ti misma.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}